// Central registry of case result cards used by the hub, homepage spotlight,
// and practice-area blurbs. Individual case pages are their own components
// with unique long-form narratives and graphics.
export const caseResults = [
  {
    slug: 'retained-surgical-tool-settlement',
    path: '/case-results/retained-surgical-tool-settlement',
    practiceArea: 'Medical Malpractice',
    practiceAreaSlug: 'med-malpractice',
    headline: 'Confidential Settlement for Retained Surgical-Tool Fragment',
    summary:
      'A broken surgical-tool fragment caused five days of severe pain and required a second operation. Amy obtained a confidential settlement without filing a lawsuit.',
    result: 'Confidential pre-litigation settlement',
    injury: 'Retained surgical-tool fragment requiring a second surgery',
    location: 'Washington State',
    featured: true,
    order: 1,
  },
  {
    slug: 'restaurant-slip-fall-wrist-fracture',
    path: '/case-results/restaurant-slip-fall-wrist-fracture',
    practiceArea: 'Slip and Fall',
    practiceAreaSlug: 'slip-and-falls',
    headline: 'Six-Figure Settlement for Dominant-Wrist Fracture from Wet-Floor Slip and Fall',
    summary:
      'A slip on a wet floor at a business caused a dominant-wrist fracture requiring permanent hardware. Amy secured a six-figure settlement without filing a lawsuit.',
    result: 'Six-figure pre-litigation settlement',
    injury: 'Dominant-wrist fracture requiring permanent hardware',
    location: 'Western Washington',
    featured: true,
    order: 2,
  },
];

export const getCaseBySlug = (slug) => caseResults.find((c) => c.slug === slug);
export const getFeaturedCases = () => caseResults.filter((c) => c.featured);
export const getCasesByPracticeAreaSlug = (slug) =>
  caseResults.filter((c) => c.practiceAreaSlug === slug);
